import React, { useState } from "react";
import "../styles/Contact.css";

const Contact = () => {
  const [formStatus, setFormStatus] = useState(false);
  const [errors, setErrors] = useState({ email: "", mobile: "" });

  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const validateMobile = (mobile) => {
    const regex = /^[0-9]{10}$/; // 10 digits only
    return regex.test(mobile);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;

    const email = form.email.value.trim();
    const mobile = form.Mobile.value.trim();

    let newErrors = { email: "", mobile: "" };
    let hasError = false;

    // Email validation
    if (!validateEmail(email)) {
      newErrors.email = "Please enter a valid email address.";
      hasError = true;
    }

    // Mobile validation
    if (!validateMobile(mobile)) {
      newErrors.mobile = "Enter a valid 10-digit mobile number.";
      hasError = true;
    }

    setErrors(newErrors);

    if (hasError) return;

    const data = new FormData(form);

    try {
      const res = await fetch("https://formspree.io/f/mpwvzjqr", {
        method: "POST",
        body: data,
        headers: { Accept: "application/json" },
      });

      if (res.ok) {
        setFormStatus(true);
        form.reset();
        setTimeout(() => setFormStatus(false), 5000);
      } else {
        alert("Something went wrong. Please try again.");
      }
    } catch (err) {
      alert("Network error. Please try again later.");
    }
  };

  return (
    <div className="contact-page">
      {/* Hero Section */}
      <section className="hero">
        <h2>Get in Touch</h2>
        <p>
          Questions, requests, or to organise a camp — contact our team using
          the form below.
        </p>
      </section>

      {/* Main Container */}
      <main className="container-contact">
        <div className="contact-layout">

          {/* Contact Form */}
          <form id="contactForm" onSubmit={handleSubmit}>
            <div className="field">
              <label htmlFor="name">Your name</label>
              <input id="name" name="name" type="text" required />
            </div>

            <div className="field">
              <label htmlFor="email">Email</label>
              <input id="email" name="email" type="email" required />
              {errors.email && <span className="error">{errors.email}</span>}
            </div>

            <div className="field">
              <label htmlFor="Mobile">Mobile No.</label>
              <input id="Mobile" name="Mobile" type="text" maxLength="10" />
              {errors.mobile && (
                <span className="error">{errors.mobile}</span>
              )}
            </div>

            <div className="field">
              <label htmlFor="subject">Subject</label>
              <input id="subject" name="subject" type="text" />
            </div>

            <div className="field">
              <label htmlFor="message">Message</label>
              <textarea id="message" name="message" required></textarea>
            </div>

            <button className="btn" type="submit">
              Send Message
            </button>

            {formStatus && (
              <div className="success-msg">
                ✅ Thank you — your message has been sent.
              </div>
            )}
          </form>
        </div>

        <div className="bottom-section">
          {/* Contact Info */}
          <aside className="contact-card">
            <h4>Contact Information</h4>
            <p>
              <strong>Address:</strong> <br />
              Spandan Blood Centre, Pune <br />
              Office No.301/302/303 Krish Landmark, Mundhwa-Kharadi Rd, <br />
              Opp. H.P. Petrol Pump, Kharadi Pune, Maharashtra 411014
            </p>

            <p>
              <strong>Phone:</strong> <br />
              +91 9607353233 / 9607453233
            </p>

            <p>
              <strong>Email:</strong> <br />
              info@spandanbloodcentre.in
            </p>

            <hr />
          </aside>

          {/* Google Map */}
          <iframe
            title="Spandan Blood Centre Map"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4280.100703877116!2d73.93353917562148!3d18.544998268426852!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2c30d20554d9d%3A0x152e2a25893e7d02!2sSpandan%20Blood%20centre%20kharadi!5e1!3m2!1sen!2sin!4v1762141517883!5m2!1sen!2sin"
            width="100%"
            height="400"
            style={{ border: 0, borderRadius: "12px" }}
            allowFullScreen=""
            loading="lazy"
          ></iframe>
        </div>
      </main>
    </div>
  );
};

export default Contact;
